import { Entity } from './Entity.js';
import { EntityFile } from '../files/EntityFile.js';
export class EntityCache {
    constructor({ initial } = {}) {
        this.cache = new Map();
        this.get = (init) => {
            if (this.cache.has(init.oid)) {
                return this.cache.get(init.oid);
            }
            const entity = new Entity(init);
            this.cache.set(init.oid, entity);
            return entity;
        };
        this.has = (oid) => {
            return this.cache.has(oid);
        };
        this.getFile = (id, options) => {
            if (this.cache.has(id)) {
                return this.cache.get(id);
            }
            const file = new EntityFile(id, options);
            this.cache.set(id, file);
            return file;
        };
        this.getCached = (oid) => {
            return this.cache.get(oid);
        };
        if (initial) {
            for (const entity of initial) {
                this.cache.set(entity.oid, entity);
            }
        }
    }
}
//# sourceMappingURL=EntityCache.js.map